module.exports = __webpack_public_path__ + "static/media/happy3.27eede81.svg";